import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// PrimeVue
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';

// PrimeVue Theme - Daha modern bir tema kullanıyoruz
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

// PrimeVue Components
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Card from 'primevue/card';
import Dialog from 'primevue/dialog';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';
import FileUpload from 'primevue/fileupload';
import Textarea from 'primevue/textarea';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Chart from 'primevue/chart';
import InputNumber from 'primevue/inputnumber';
import Divider from 'primevue/divider';
import Toolbar from 'primevue/toolbar';
import Menu from 'primevue/menu';
import Tooltip from 'primevue/tooltip';
import Badge from 'primevue/badge';
import ProgressSpinner from 'primevue/progressspinner';

const app = createApp(App);

app.use(router);
app.use(store);
app.use(PrimeVue, {
    ripple: true, // Daha modern click efekti
    inputStyle: 'filled', // Daha modern input stili
});
app.use(ToastService);
app.use(ConfirmationService);
app.directive('tooltip', Tooltip);

// Register PrimeVue components
app.component('Button', Button);
app.component('InputText', InputText);
app.component('Password', Password);
app.component('DataTable', DataTable);
app.component('Column', Column);
app.component('Card', Card);
app.component('Dialog', Dialog);
app.component('Toast', Toast);
app.component('ConfirmDialog', ConfirmDialog);
app.component('Dropdown', Dropdown);
app.component('Calendar', Calendar);
app.component('FileUpload', FileUpload);
app.component('Textarea', Textarea);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('Chart', Chart);
app.component('InputNumber', InputNumber);
app.component('Divider', Divider);
app.component('Toolbar', Toolbar);
app.component('Menu', Menu);
app.component('Badge', Badge);
app.component('ProgressSpinner', ProgressSpinner);

app.mount('#app');